import { observable} from "mobx";
const postData = {
    msgCheckData: {
        loginName: '',
        idNumber: "",
        idType: '1',
        validateCode: "",
    }
}

const postStore = observable(postData)

export default postStore;
